import { GenIcon } from '../helpers/IconBase.es.js';

const HomepageAlternativeOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M3 10.714L12 3L21 10.714",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M4 10V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V10",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.4292 21V16.571C9.4292 16.0406 9.63991 15.5319 10.015 15.1568C10.3901 14.7818 10.8988 14.571 11.4292 14.571H12.5722C13.1026 14.571 13.6113 14.7818 13.9864 15.1568C14.3615 15.5319 14.5722 16.0406 14.5722 16.571V21",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { HomepageAlternativeOutlined };
